import { Skeleton } from "@/app/components/shadcn/skeleton";
import { cn } from "@/app/utils/cn";

interface AgreementsSkeletonProps {
  className?: string;
  count?: number;
}

const AgreementsSkeleton = ({ 
  className, 
  count = 3 
}: AgreementsSkeletonProps) => {
  return (
    <div className={cn("space-y-4 pt-4 border-t border-gray-100", className)}>
      {/* Title Skeleton */}
      <Skeleton className="h-4 w-32" />

      {/* Agreement Items */}
      <div className="space-y-4">
        {Array.from({ length: count }).map((_, index) => (
          <div key={index} className="flex flex-row items-start space-x-3">
            {/* Checkbox Skeleton */}
            <Skeleton className="size-5 mt-0.5 shrink-0" />
            
            {/* Label Skeleton */}
            <div className="flex-1 space-y-1.5">
              <Skeleton className="h-4 w-full max-w-md" />
              <Skeleton className="h-4 w-3/4 max-w-sm" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgreementsSkeleton;